import * as yup from 'yup';

export type UploadedFile = {
  name: string;
  size: number;
  content: string;
};

export type CreateKeyFormValues = {
  name: string;
  method: 'pkcs' | 'jwt';
  encryptionEnabled: boolean;
  upload: UploadedFile | null;
  acknowledge: boolean;
};

const UPLOAD_REQUIRED_MESSAGE = 'A file is required for this method';
const ACKNOWLEDGE_REQUIRED_MESSAGE =
  'You must acknowledge the access level of this key';

const uploadRequired = (method: string, encryptionEnabled: boolean) =>
  method === 'jwt' || (method === 'pkcs' && encryptionEnabled);

export const createKeyModalSchema = yup
  .object({
    name: yup.string().trim().label('Name').required(),
    method: yup.string().oneOf(['pkcs', 'jwt']).required(),
    encryptionEnabled: yup.boolean().required(),
    upload: yup
      .mixed()
      .nullable()
      .when(['method', 'encryptionEnabled'], {
        is: uploadRequired,
        then: yup.mixed().required(UPLOAD_REQUIRED_MESSAGE),
        otherwise: yup.mixed().nullable()
      }),
    acknowledge: yup
      .boolean()
      .required(ACKNOWLEDGE_REQUIRED_MESSAGE)
      .oneOf([true], ACKNOWLEDGE_REQUIRED_MESSAGE)
  })
  .required();
